module.exports = __webpack_public_path__ + "static/media/004_Letter.7adc482c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/farmers/004_Letter.png
// module id = 415
// module chunks = 0